export default __webpack_public_path__ + "static/media/negative.18b68202.svg";